<script lang="ts">
  import { Compass, Share2 } from "lucide-svelte";

  export interface TrafficSourceItem {
    name: string;      // 例如: 直接访问、百度搜索、谷歌搜索、社交媒体、外部链接
    pv: number;
    percentage: number;
    color?: string;    // 自定义颜色类或 hex
  }

  interface Props {
    sources?: TrafficSourceItem[];
    t: (key: string, params?: Record<string, any>) => string;
  }

  let { sources = [], t }: Props = $props();

  // 预设色彩搭配
  const defaultColors = [
    'bg-primary',
    'bg-emerald-500',
    'bg-sky-500',
    'bg-amber-500',
    'bg-purple-500',
    'bg-rose-500'
  ];
</script>

<div class="rounded-xl border bg-card p-5 shadow-sm flex flex-col justify-between">
  <div>
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <div>
        <h3 class="text-sm font-semibold">{t('dashboard.charts.sources_title') || '流量来源渠道'}</h3>
        <p class="text-xs text-muted-foreground">{t('dashboard.charts.sources_desc') || '全站访客的前置引流渠道分布'}</p>
      </div>
      <div class="p-2 bg-primary/10 rounded-lg text-primary">
        <Compass class="size-4" />
      </div>
    </div>

    <!-- Content List -->
    {#if sources && sources.length > 0}
      <!-- 组合进度条/占比视觉条 -->
      <div class="w-full h-3 bg-muted rounded-full overflow-hidden flex my-4 p-0.5 gap-0.5">
        {#each sources as source, i}
          <div 
            class="{source.color || defaultColors[i % defaultColors.length]} h-full first:rounded-l-full last:rounded-r-full transition-all duration-500"
            style="width: {source.percentage}%"
            title="{source.name}: {source.percentage}%"
          ></div>
        {/each}
      </div>

      <div class="space-y-2.5 mt-4">
        {#each sources as source, i}
          <div class="flex items-center justify-between text-xs">
            <div class="flex items-center gap-2">
              <span class="size-2.5 rounded-full {source.color || defaultColors[i % defaultColors.length]} shrink-0"></span>
              <span class="font-medium text-foreground">{source.name}</span>
            </div>
            <div class="flex items-center gap-3 text-muted-foreground">
              <span class="font-semibold text-foreground">{source.pv.toLocaleString()} <span class="text-[10px] font-normal">PV</span></span>
              <span class="w-12 text-right text-[11px] bg-muted px-1.5 py-0.5 rounded font-mono">{source.percentage}%</span>
            </div>
          </div>
        {/each}
      </div>
    {:else}
      <div class="flex h-48 items-center justify-center text-xs text-muted-foreground">
        {t('dashboard.charts.no_sources_data') || '暂无流量来源数据'}
      </div>
    {/if}
  </div>
</div>